import React from 'react'
import ExpenseReport, { ExpenseReportContext } from 'src/app/ExpenseReport/ExpenseReport'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { expenseReportRouteProps } from 'src/navigation/routeProps'

const ExpenseReportAppRoute: AppRoute = {
  id: AppLocation.ExpenseReport,
  routeProps: expenseReportRouteProps,
  component: <ExpenseReport context={ExpenseReportContext.accounting}/>,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default ExpenseReportAppRoute
